import { useCallback } from 'react';
import { PreviewColumnT } from 'routes/Cellar/types';

export const useGetColumnType = (
    isNewTable: boolean,
    tableColumns: ResponseColumnT[] | undefined,
) =>
    useCallback(
        (column: PreviewColumnT): DataTypesT | null => {
            if (isNewTable) {
                return column.type;
            }
            if (tableColumns) {
                const existingColumn = tableColumns.find(
                    (col) => col.label === column.label,
                );
                return existingColumn ? existingColumn.type : null;
            }
            return null;
        },
        [isNewTable, tableColumns],
    );
